/* eslint-disable no-debugger */
import {API_URL} from './api-base'

const apiURL = API_URL

function createApiError(message, status, endpoint, data) {
  const error = new Error(message)
  error.status = status
  error.endpoint = endpoint
  error.data = data
  return error
}

async function client(
  endpoint,
  {data, token, headers: customHeaders, ...customConfig} = {},
) {
  const config = {
    method: data ? 'POST' : 'GET',
    body: data ? JSON.stringify(data) : undefined,
    headers: {
      Authorization: token ? `Bearer ${token}` : undefined,
      'Content-Type': data ? 'application/json' : undefined,
      ...customHeaders,
    },
    ...customConfig,
  }

  return window.fetch(`${apiURL}/${endpoint}`, config).then(async response => {
    if (response.status === 401) {
      // TODO: logout()
      // refresh the page for them
      // window.location.assign(window.location)
      return Promise.reject(
        createApiError('Please re-authenticate.', 401, endpoint),
      )
    }

    if (response.status === 404) {
      const errObjectString = await response.text()
      if (errObjectString === 'Not Found') {
        return Promise.reject(createApiError('Not found', 404, endpoint))
      }
      let errObject
      try {
        errObject = JSON.parse(errObjectString)
      } catch {
        errObject = {}
      }
      return Promise.reject(
        createApiError(errObject?.message || 'Not found', 404, endpoint),
      )
    }

    // Safe JSON parser — reads body as text first to avoid SyntaxError
    // from Response.json() on empty or non-JSON responses (Fixes OOE-UI-Z)
    const safeParseJson = async res => {
      try {
        const text = await res.text()
        return text ? JSON.parse(text) : null
      } catch {
        return null
      }
    }

    let ignoreInviteData
    try {
      ignoreInviteData = await safeParseJson(response.clone())
    } catch {
      ignoreInviteData = null
    }
    if (ignoreInviteData?.message === 'ignore invite error') {
      return
    }

    let data
    if (response.status === 201) {
      data = await safeParseJson(response.clone())
      if (data === null) data = undefined
    }
    if (response.status !== 204 && response.status !== 201) {
      if (
        ['application/pdf', 'image/png'].includes(
          response.headers.get('Content-Type'),
        )
      ) {
        data = await response.blob()
      } else {
        console.log(
          `[API JSON from: ${response.url}, Status: ${response.status}`,
        )
        data = await safeParseJson(response)
        if (data === null) {
          console.warn(
            `[API empty JSON from: ${response.url}, Status: ${response.status}`,
          )
          data = {}
        }
      }
    }
    if (response.ok) {
      // eslint-disable-next-line no-prototype-builtins
      if (data && data.hasOwnProperty('sfToken')) {
        sessionStorage.setItem('sfToken', JSON.stringify(data.sfToken))
        delete data.sfToken
      }
      const stackColor = response.headers.get('x-stack-color')
      if (stackColor) sessionStorage.setItem('stackColor', stackColor)
      return data
    } else {
      return Promise.reject(
        createApiError(
          data?.message || `API error: ${response.status} ${endpoint}`,
          response.status,
          endpoint,
          data,
        ),
      )
    }
  })
}

export {client}
